'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbStripRbOnDemandController.$inject = ['$http'];


var _module = angular.module('cb.strips.cbRbOnDemandV1', []);
var _ = {
    each: _each3.default
};

_module.directive('cbStripRbOnDemandV1', cbStripRbOnDemandV1);

exports.default = _module;


function cbStripRbOnDemandV1() {
    return {
        restrict: 'A',
        controller: cbStripRbOnDemandController,
        controllerAs: 'rbondemand'
    };
}

function cbStripRbOnDemandController($http) {
    var vm = this;

    // Object for selectable products
    vm.producten = {
        PJA: { key: '&productid=1', name: 'Juridisch Advies' },
        PJAO: { key: '&productid=20', name: 'Juridisch Advies en Onderhandelen' }
    };

    // Object for general themes, which are linked to groups of selectable subthemes
    vm.themas = {
        huis: { key: '&themeid=74902949-a09b-46dd-ad72-4f789dc8f30e', name: 'Huis' },
        werk: { key: '&themeid=90ba4e9c-9c81-47b3-ac07-0ef02b5ec47e', name: 'Werk' },
        consument: { key: '&themeid=046a3491-ca84-4c64-b1b2-b1a12bd38335', name: 'Consument' }
    };

    // Object for selectable subthemes
    vm.subthemas = {
        huis: {
            huren: {
                key: '&casetypeid=fc2e698b-65ef-4ff7-944c-cd064b61dd42',
                name: 'Huur of verhuur',
                thema: 'huis',
                situaties: {
                    situatie1: { description: 'Mijn huurcontract is opgezegd.' },
                    situatie2: { description: 'Ik heb een probleem met de verhuurder.' },
                    situatie3: { description: 'Ik wil het verhuurcontract opzeggen.' }
                }
            },
            kopen: {
                key: '&casetypeid=50cc2f31-3a24-49a3-8fd5-30b8e0dc9241',
                name: 'Aankoop of verkoop',
                thema: 'huis',
                situaties: {
                    situatie1: { description: 'Er zijn gebreken aan mijn nieuwe woning.' },
                    situatie2: { description: 'Ik heb problemen met de aannemer.' },
                    situatie3: { description: 'Er zijn problemen bij de verkoop van mijn woning.' }
                }
            },
            buren: {
                key: '&casetypeid=5eae3a90-e08b-403a-ad1c-78a7b096c378',
                name: 'Problemen met de buren',
                thema: 'huis',
                situaties: {
                    situatie1: { description: 'Er zijn problemen over de erfafscheiding.' },
                    situatie2: { description: 'Er is een grensgeschil.' },
                    situatie3: { description: 'Ik heb overlast van de buren.' }
                }
            },
            anders: {
                key: '&casetypeid=c1ecefa2-c804-4b98-9e1b-fb776d8d8265',
                name: 'Anders',
                thema: 'huis'
            }
        },
        werk: {
            ontslag: {
                key: '&casetypeid=95bfbe9d-9ff2-4b25-9f5f-d378f91dcc5b',
                name: 'Ontslag',
                thema: 'werk',
                situaties: {
                    situatie1: { description: 'Ik word ontslagen/ik neem ontslag.' },
                    situatie2: { description: 'Ik wil hulp bij een overeenkomst.' },
                    situatie3: { description: 'Ik heb een arbeidsconflict.' }
                }
            },
            salaris: {
                key: '&casetypeid=e39e9da9-3fcc-4685-947f-994ec39d42cf',
                name: 'Salaris',
                thema: 'werk',
                situaties: {
                    situatie1: { description: 'Ik heb nog geld tegoed van mijn baas.' },
                    situatie2: { description: 'Er wordt ten onrechte geld ingehouden.' },
                    situatie3: { description: 'Mijn werkgever komt CAO afspraken niet na.' }
                }
            },
            arbeidscontract: {
                key: '&casetypeid=c6503610-265f-479d-82fd-10e72908e4cd',
                name: 'Arbeidscontract',
                thema: 'werk',
                situaties: {
                    situatie1: { description: 'Ik wil onder mijn concurrentiebeding uit.' },
                    situatie2: { description: 'Ik heb problemen met mijn ziekmelding/re-integratie.' },
                    situatie3: { description: 'Ik heb vragen over mijn arbeidscontract.' }
                }
            },
            anders: {
                key: '&casetypeid=035d3ae5-ec68-4a93-af7b-2c79336f4ff3',
                name: 'Anders',
                thema: 'werk'
            }
        },
        consument: {
            aankopen: {
                key: '&casetypeid=2fc7d46e-c33a-4e3d-a12a-ca24b2cd3633',
                name: 'Aankopen',
                thema: 'consument',
                situaties: {
                    situatie1: { description: 'Ik ben opgelicht.' },
                    situatie2: { description: 'Ik heb iets gekocht maar dat is kapot of werkt niet.' },
                    situatie3: { description: 'Ik heb spijt van mijn aankoop.' }
                }
            },
            dienstverleners: {
                key: '&casetypeid=30a1f1ed-73e2-425b-9f6a-c00521dd0211',
                name: 'Dienstverleners',
                thema: 'consument',
                situaties: {
                    situatie1: { description: 'Ik heb problemen met een energiemaatschappij.' },
                    situatie2: { description: 'Ik een probleem met de klusjesman.' },
                    situatie3: { description: 'Ik heb een probleem met mijn accountant.' }
                }
            },
            geldzaken: {
                key: '&casetypeid=0951f4dd-8746-4240-8f39-8a79f7fdbd27',
                name: 'Geld',
                thema: 'consument',
                situaties: {
                    situatie1: { description: 'Mijn claim bij een verzekeraar is afgewezen.' },
                    situatie2: { description: 'Ik heb een probleem met mijn bank.' },
                    situatie3: { description: 'Ik krijg mijn geleend geld niet terug.' }
                }
            },
            anders: {
                key: '&casetypeid=d2f6379e-7988-4ebe-99be-d5fcd4fc501e',
                name: 'Anders',
                thema: 'consument'
            }
        }
    };

    // Base URL
    vm.legalguardLink = 'https://juridischehulp.centraalbeheer.nl/Webservices/RequestOrder.aspx?labelid=c1248b91-61bb-4e8b-b2e5-36bf2f106f77';
    vm.link = vm.legalguardLink;
    vm.dummyPressed = false;

    vm.getLink = function (name, theme) {
        //Set general thema which belongs to the selected subthema
        if (theme) {
            vm.selectedThema = vm.themas[theme].key;
        }

        //If a product is selected, set active variable for comparatorv2__item--is-selected class
        if (name === 'PJA' || name === 'PJAO') {
            vm.activeProduct = name;
        }

        //Set a variable for whether or not the subthema 'Anders' is selected
        vm.andersSelected = name === 'Anders';

        //Update URL parameters
        vm.link = vm.legalguardLink + vm.selectedProduct + vm.selectedThema + vm.selectedSubthema;
    };

    vm.formInvalid = function (thema, product) {
        //If both a thema and product are selected, the form is valid
        if (thema !== undefined && product !== undefined) {
            return false;
        } else {
            if (thema === undefined) {
                vm.noThema = true;
            }
            if (product === undefined) {
                vm.noProduct = true;
            }
            return true;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/rb-on-demand-v1/rb-on-demand.directive.js
// module id = 955
// module chunks = 1